
import { useState, useEffect } from "react";

import { useRef } from "react";
import Globe from "react-globe.gl";
import "./GlobeComp.css";
import Popup from "./popups/Popup";
// import { createStripedMaterial } from "./helpers/stripedMaterial";

function App() {
  const elementVariable = useRef(null);
  const globeRef = useRef();
  const animationTimeoutId = useRef();
  
  // Configurable frame rate (in milliseconds)
  // 16.67ms = 60fps, 33.33ms = 30fps, 66.67ms = 15fps
  const [frameInterval] = useState(16.67); // Default to 10fps

  // let polygonsColors = [
  //   { SOV_A3: "AFG", color: "rgba(100, 0, 0, 0.6)" },
  //   { SOV_A3: "ARG", color: "rgba(100, 0, 0, 0.6)" },
  //   { SOV_A3: "FR1", color: "rgba(200, 100, 0, 0.6)" },
  // ];

  // let potentialPolygonCapColors = {
  //   1: "rgba(100, 0, 0, 0.6)",
  //   2: "rgba(200, 100, 0, 0.6)",
  //   3: "rgba(200, 100, 0, 0.6)",
  //   4: "rgba(200, 100, 0, 0.6)",
  //   5: "rgba(200, 100, 0, 0.6)",
  // };

  const [nodes, setNodes] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [visaDetails, setVisaDetails] = useState({});
  const [isLoading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [showPopupBool, setPopupBool] = useState(false);

  useEffect(() => {
    getAllNodes();
  }, []);

  // Custom animation loop with configurable frame rate
  useEffect(() => {
    if (globeRef.current) {
      const globe = globeRef.current;
      
      // Wait for globe to be fully initialized and events set up
      setTimeout(() => {
        // Different approach - hijack requestAnimationFrame instead of render
        const originalRAF = window.requestAnimationFrame;
        let rafControlActive = false;
        let pendingCallbacks = [];
        
        // Override requestAnimationFrame to control when callbacks execute
        window.requestAnimationFrame = (callback) => {
          if (rafControlActive) {
            // Store callback instead of executing immediately
            pendingCallbacks.push(callback);
            return pendingCallbacks.length; // Return a fake ID
          } else {
            // During initialization, use normal RAF
            return originalRAF(callback);
          }
        };
        
        // Start controlling RAF after globe is set up
        setTimeout(() => {
          rafControlActive = true;
        }, 1000);
        
        // Disable automatic controls updates but keep events working
        if (globe.controls && globe.controls()) {
          const controls = globe.controls();
          controls.enableDamping = false;
          controls.autoRotate = false;
          // Keep controls.enabled = true for events to work
        }
        
        // Start our manual rendering loop
        const customAnimationLoop = () => {
          // Manual controls update
          if (globe.controls && globe.controls().update) {
            globe.controls().update();
          }
          
          // Execute pending RAF callbacks (this triggers the render)
          const callbacks = [...pendingCallbacks];
          pendingCallbacks = [];
          callbacks.forEach(callback => {
            try {
              callback(performance.now());
            } catch (e) {
              console.warn('RAF callback error:', e);
            }
          });
          
          // Schedule next frame at OUR interval
          animationTimeoutId.current = setTimeout(customAnimationLoop, frameInterval);
        };
        
        // Start our custom loop
        animationTimeoutId.current = setTimeout(customAnimationLoop, frameInterval);
      }, 2000); // Give globe 2 seconds to set up events properly
      
      // Cleanup function
      return () => {
        if (animationTimeoutId.current) {
          clearTimeout(animationTimeoutId.current);
        }
        // Restore original RAF
        window.requestAnimationFrame = window.requestAnimationFrame.originalRAF || window.requestAnimationFrame;
      };
    }
  }, [frameInterval, nodes]); // Re-run when frameInterval changes or nodes load

  const getAllNodes = async () => {
    let res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}`);
    // let res = await fetch("https://countrydata-en5f.onrender.com/countryData");
    console.log(res);
    const text = await res.json();
    // console.log(text);

    setNodes(text);
    setLoading(false);
    //   });
  };

  const showPopup = (e) => {
    console.log(e);
    setPopupBool(true);
    setVisaDetails(e.properties);
  }

  const hidePopup = () => {
    setPopupBool(false);
  }

  if (isLoading) {
    return <div className="App">Loading...</div>;
  }


  return (
    <div>
      {/* Frame Rate Controls */}
      {/* <div style={{ 
        position: 'absolute', 
        top: '10px', 
        left: '10px', 
        zIndex: 1000, 
        background: 'rgba(0,0,0,0.7)', 
        color: 'white', 
        padding: '10px', 
        borderRadius: '5px',
        fontSize: '12px'
      }}>
        <div>Frame Rate Control:</div>
        <button onClick={() => setFrameInterval(16.67)} style={{margin: '2px'}}>60fps</button>
        <button onClick={() => setFrameInterval(33.33)} style={{margin: '2px'}}>30fps</button>
        <button onClick={() => setFrameInterval(66.67)} style={{margin: '2px'}}>15fps</button>
        <button onClick={() => setFrameInterval(100)} style={{margin: '2px'}}>10fps</button>
        <div>Current: {Math.round(1000/frameInterval)}fps</div>
      </div> */}
      <div className="three-js-globe">
        {/* {nodes} */}
        <Globe
          ref={globeRef}
          globeImageUrl={"//unpkg.com/three-globe/example/img/earth-dark.jpg"}
          polygonsData={nodes}
          polygonCapColor={(e) => {
            return e.properties?.visaEaseColors
          }}
          polygonSideColor={() => "transparent"} // Don't render polygon sides for performance
          polygonStrokeColor={() => "#000"}
          onGlobeClick={() => {
            hidePopup();
          }}
          onPolygonClick={(e) => {
            showPopup(e);
          }}
          // Performance optimizations
          hexPolygonResolution={1} // Lower detail country borders for better performance
          pointResolution={1} // Lower detail points for better performance
          arcCurveResolution={1} // Lower detail arcs for better performance
          hexBinResolution={1} // Lower detail hex bins for better performance
          showAtmosphere={false} // Disable expensive atmosphere rendering
          atmosphereColor={undefined} // Remove atmosphere completely
          rendererConfig={{
            antialias: false,        // Major GPU savings
            powerPreference: "low-power", // Use integrated GPU if available
            precision: "lowp"        // Lower precision calculations
          }}
        />
      </div>
      {showPopupBool && <Popup visaDetails={visaDetails} onClose={hidePopup} />}
      <div ref={elementVariable}></div>
    </div>
  );
}

export default App;
